<template>
    <backend-layout title="User Feedback">
        <div class="has-table md:rounded border-gray-100 dark:bg-gray-900/70 bg-white border dark:border-gray-800 mb-6" v-if="feedbacks.data.length > 0">
            <header class="card-header">
                <p class="card-header-title">
                    <span class="icon"><i class="mdi mdi-bullhorn-outline"></i></span>
                    Feedback
                </p>
            </header>
            <div class="card-content">
                <table>
                    <thead>
                    <tr>
                        <th>User</th>
                        <th>Type</th>
                        <th>Message</th>
                        <th>Reviewed</th>
                        <th>Created</th>
                        <!--                        <th></th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="feedback in feedbacks.data">
                        <td data-label="Username">{{ feedback.user }}</td>
                        <td data-label="Type">
                            <button class="button small"
                                    :class="{'green':feedback.type === 'like','red':feedback.type === 'dislike','blue':feedback.type === 'suggestion'}"
                                    type="button">
                                {{ feedback.type }}
                            </button>
                        </td>
                        <td data-label="Message">{{ feedback.message }}</td>
                        <td data-label="Reviewed">
                            {{ feedback.reviewed }}
                        </td>
                        <td data-label="Created">
                            <small class="text-gray-500"
                                   title="Oct 25, 2021">{{ new Date(feedback.created_at).toDateString() }}</small>
                        </td>
                        <!--                        <td class="actions-cell">-->
                        <!--                            <div class="buttons right nowrap">-->
                        <!--                                <button class="button small green &#45;&#45;jb-modal" data-target="sample-modal-2"-->
                        <!--                                        type="button">-->
                        <!--                                    <span class="icon"><i class="mdi mdi-eye"></i></span>-->
                        <!--                                </button>-->
                        <!--                                <button class="button small red &#45;&#45;jb-modal" data-target="sample-modal"-->
                        <!--                                        type="button">-->
                        <!--                                    <span class="icon"><i class="mdi mdi-trash-can"></i></span>-->
                        <!--                                </button>-->
                        <!--                            </div>-->
                        <!--                        </td>-->
                    </tr>
                    </tbody>
                </table>
                <pagination :links="feedbacks.links" :active-page="feedbacks.current_page"
                            :total-pages="feedbacks.total"></pagination>
            </div>
        </div>
        <div v-else>
            No feedback available!
        </div>
    </backend-layout>
</template>

<script>
import BackendLayout from "@/Layouts/BackendLayout";
import Pagination from "@/Components/Pagination";

export default {
    name: "Feedback",
    props: {
        feedbacks: Object
    },
    components: {Pagination, BackendLayout},
    methods: {
        referrerContact(referrer) {
            return referrer.phone ?? referrer.email;
        }
    }
}
</script>

<style scoped>

</style>
